<template>
  <div v-if="vsl" class="page-wrapper">
    <div class="page-content">
      <div class="headerBackgroundImage p-5" v-html="vsl.fields.header"></div>
      <main class="container col-12 mx-auto my-1 px-5">
        <template v-if="!vsl.fields.headerBackgroundImage">
          <div class="headerCustom p-3 mb-0 pb-0 text-center" v-html="vsl.fields.styles"></div>
        </template>

        <template v-if="vsl.fields.vimeoUrl">
          <VideoBox :url="vsl.fields.vimeoUrl"
                    :orderButtonTime="vsl.fields.orderButtonPopTime"
                    :orderForm="vsl.fields.orderForm"
                    :buttonText="vsl.fields.buttonText ? vsl.fields.buttonText : 'Order Now'"
          />
        </template>

        

        <div class="py-3" v-html="vsl.fields.subheader"></div>
      </main>
      <ExitPop v-if="showExitPop" :modal="exitpop" />
    </div>
    <Footer/>
  </div>
</template>

<style scoped>



</style>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex'
import ExitPop from "@/components/ExitPop.vue";
import Footer from "@/components/Footer.vue";
import VideoBox from "@/components/VideoBox.vue";
import { themeOptions } from '@/style/themes.js'
import axios from 'axios'

export default Vue.extend({
  name: 'vsl',
  computed: {
    ...mapGetters({
      vsl: 'getVSL',
    }),
  },
  components: {
    VideoBox,
    ExitPop,
    Footer,
  },
  data: () => ({
    theme: null,
    showExitPop: false,
    exitpop:  null
  }),
  mounted() {
    const waitForPageLoad = (timeout=0) => {
      const startTime = new Date().getTime();
      return new Promise((resolve, reject)=>{
        const timer = setInterval(() => {
          let now = new Date().getTime();
          if(this.vsl.fields){
            clearInterval(timer);
            resolve();
          } else if(now - startTime >= timeout){
            clearInterval(timer);
            reject();
          }
        }, 100);
      });
    }

    waitForPageLoad(800).then(() => {
      getPageInfo();
      getAdditionalContent();
    }).catch(() => $('.headerBackgroundImage').css('background-color', '#a3a3a3'));

    const getPageInfo = () => {
      this.$gtag.pageview({ 
        'page_title': this.vsl.fields.vslTitle,
        'campaign_code': this.vsl.fields.campaignCode.fields.campaignCode, 
        'campaign': this.vsl.fields.campaignCode.fields.campaignCode, 
        'page_path': '/vsl/' + this.vsl.fields.slug,
      })
      document.title = this.vsl.fields.metaTitle
      document.getElementsByTagName('meta')["description"].content = this.vsl.fields.metaDescription
      $('iframe').css('max-width', '100%')
      $('iframe').css('width', '100%')

        if(this.vsl.fields.headerBackgroundImage) {
        $('.headerBackgroundImage').css('background-image', 'url(https:' + this.vsl.fields.headerBackgroundImage.fields.file.url + ')')
      }

        if(this.vsl.fields.backgroundColor && !this.vsl.fields.backgroundImage) {
        $('body').css('background-color', this.vsl.fields.backgroundColor)
      }

        if(this.vsl.fields.backgroundImage) {
        $('body').css('background-image', 'url(https:' + this.vsl.fields.backgroundImage.fields.file.url + ')')
      }
      let theme = this.vsl.fields.theme ? themeOptions[this.vsl.fields.theme] : 'primary'
      $('#orderButton').addClass('btn-' + theme)
    };

    const getAdditionalContent = () => {
      let contentType = this.vsl.fields.exitPop ? this.vsl.fields.exitPop.sys.contentType.sys.id : null
      if (contentType == 'exitPop') {
        this.showExitPop = true;
        this.exitpop = this.vsl.fields.exitPop.fields;
      }
    };

    const reportPageView = () => {
      try{
        var utmad = this.getUtmAd();

        if(utmad) {
          var reportContent = {
              "topic": "promo_viewed",
              "applicationId": "75004f90-f700-4795-aa71-53f072e6ba83",
              "scopes": [{"topic": "utmad", "value": utmad}],
              "actorClaims": [{"typeId": 2, "value": this.getEmail()}]
          };

          axios.post(process.env.VUE_APP_TMI_API_ROOT_URL + '/ux/appaction', reportContent);
        }
      } catch {}
    }

    reportPageView();
  },
  methods: {
    ...mapActions([
      'getVSL',
    ]),
    
    getUtmAd()
    {
      if (sessionStorage.getItem('utm_ad'))
      {
        return sessionStorage.getItem('utm_ad')
      }
      else if (localStorage.getItem('utm_ad'))
      {
        return localStorage.getItem('utm_ad')
      }
    },

    getEmail()
    {
      if (sessionStorage.getItem('email'))
      {
        return sessionStorage.getItem('email')
      }
      else if (localStorage.getItem('email'))
      {
        return localStorage.getItem('email')
      }
    }
  },
  created() {
    this.getVSL(this.$route.params.slug);
  }
});
window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
  'pageType': 'vsl'
});
</script>

